
import React from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function OurStory() {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>();

  return (
    <section ref={ref} className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div
            className={`transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
            }`}
          >
            <span className="text-xs font-semibold text-[#00989e] uppercase tracking-widest">
              How It Started
            </span>
            <h2
              className="text-3xl lg:text-4xl font-bold text-slate-900 mt-3 mb-6 leading-tight"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              From a one-woman mission to a creative powerhouse
            </h2>
            <div className="space-y-5 text-slate-600 text-[15px] leading-relaxed">
              <p>
                unuu was born in 2019 when founder <strong>Maria</strong> noticed a gap in the market: small and medium
                businesses were pouring money into social media with little to show for it. The content felt generic,
                the strategies were copy-paste, and the results were underwhelming.
              </p>
              <p>
                She set out to change that. Armed with a background in brand strategy and a genuine love for storytelling,
                Maria built unuu around one simple belief —{' '}
                <strong>your audience doesn’t want to be sold to; they want to connect with you</strong>.
              </p>
              <p>
                Today, unuu partners with over 50 brands across the UK, crafting bespoke social media strategies that feel
                human, look stunning, and deliver measurable growth. Every campaign we run starts with listening — because
                the best content comes from truly understanding who you are.
              </p>
            </div>
          </div>

          <div
            className={`relative transition-all duration-700 delay-200 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
            }`}
          >
            <div className="relative">
              <div className="w-full h-[480px] rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/c2cdffe5f060fa85a2c6f0696d0a742a.jpg"
                  alt="Maria, founder of unuu"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-[#00989e] text-white rounded-2xl px-6 py-4 shadow-xl">
                <p className="text-3xl font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  50+
                </p>
                <p className="text-sm text-white/90">Brands Transformed</p>
              </div>
              <div className="absolute -top-4 -right-4 w-32 h-32 bg-[#00989e]/10 rounded-full blur-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
